import axios from 'axios'
import router from '../router'
import { Message } from 'element-ui'

// 示例：输出当前环境
// console.log(`Running in ${process.env.VUE_APP_MODE} mode`)

// 创建一个axios实例，并设置基础URL和超时时间
const service = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    timeout: 5000
})

// 请求拦截器
// 在请求发送前，拦截请求配置，如果存在token，则将其添加到请求头中
service.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token')
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// 响应拦截器
// 在响应返回后，拦截响应数据，如果状态码不是200，则显示错误信息，并根据状态码决定是否跳转到登录页面
service.interceptors.response.use(
    response => {
        const res = response.data

        if (res.code !== 200) {
            Message.error(res.message || 'Error')

            if (res.code === 401) {
                router.push('/login')
            }
            return Promise.reject(new Error(res.message || 'Error'))
        } else {
            return res
        }
    },
    error => {
        Message.error(error.message || 'Error')
        return Promise.reject(error)
    }
)



export default service